import Phaser from 'phaser';

const BG_OUTER = 0x7f1d1d;
const BG_INNER = 0xb91c1c;
const REACTOR_OUTER = 0xfde68a;
const REACTOR_INNER = 0xfbbf24;
const REACTOR_GLOW = 0xffffff;
const STROKE = 0x0a0f1f;

export function drawRepulsor(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const triR = r * 0.62;
  const innerR = triR * 0.55;
  const cy = (triR - innerR) / 2;
  drawTrianglePoly(g, 0, cy, triR, -Math.PI / 2, REACTOR_OUTER, STROKE, Math.max(1, Math.floor(stroke * 0.7)));
  drawTrianglePoly(g, 0, cy, innerR, Math.PI / 2, REACTOR_INNER, STROKE, Math.max(1, Math.floor(stroke * 0.6)));

  g.fillStyle(REACTOR_GLOW, 1);
  g.fillCircle(0, cy, r * 0.14);
}

function drawTrianglePoly(
  g: Phaser.GameObjects.Graphics,
  cx: number,
  cy: number,
  radius: number,
  rotation: number,
  fill: number,
  stroke: number,
  strokeW: number,
) {
  const pts: { x: number; y: number }[] = [];
  for (let i = 0; i < 3; i++) {
    const a = rotation + (i * Math.PI * 2) / 3;
    pts.push({ x: cx + radius * Math.cos(a), y: cy + radius * Math.sin(a) });
  }
  g.fillStyle(fill, 1);
  g.lineStyle(strokeW, stroke, 1);
  g.beginPath();
  g.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < 3; i++) g.lineTo(pts[i].x, pts[i].y);
  g.closePath();
  g.fillPath();
  g.strokePath();
}
